import {useState, ChangeEvent} from 'react'
// import {useDebouncedCallback} from 'use-debounce'
import {Input as AntdInput, InputProps} from 'antd'

import './Search.scss'
import {SearchIcon} from 'common/components'

interface SearchProps extends InputProps {
  search: string
  setSearch: (search: string) => void
}

export default function Search({search, setSearch, ...props}: SearchProps) {
  const [value, setValue] = useState(search)
  // useEffect(() => {
  //   if (value !== search) setValue(search)
  // }, [search, value])
  // const debouncedSetSearch = useDebouncedCallback(
  //   (value) => setSearch(value),
  //   300
  // )

  const handleSearchChange = (e: ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value)
    if (!e.target.value) setSearch(e.target.value)
    // debouncedSetSearch(e.target.value)
  }
  const handleEnter = () => {
    setSearch(value)
  }

  return (
    <AntdInput
      allowClear
      className="Search"
      value={value}
      type="search"
      suffix={
        <button style={{
          border: 'none', outline: 'none', backgroundColor: 'transparent',
          padding: '0', margin: '0'
        }} onClick={handleEnter}>
          <SearchIcon />
        </button> }
      // prefix={
      //   <Space size={6}>
      //     <SearchIcon />
      //     <Text as="span" weight="demiBold">
      //       Search:
      //     </Text>
      //   </Space>
      // }
      onChange={handleSearchChange}
      onPressEnter={handleEnter}
      {...props}
    />
  )
}
